import NavBar from './MyComponents/navbar/NavBar.js'
import Home from './MyComponents/home/Home.js'

function App() {
  return (
    <div className="App">
      <NavBar />
      <Home />
    </div>
  )
}

export default App;
